var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgIconJapan(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 22,
    height: 16,
    viewBox: "0 0 22 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_6042_110645)"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 16,
    rx: 2,
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M10.9997 11.7323C13.0247 11.7323 14.6663 10.0608 14.6663 7.99896C14.6663 5.9371 13.0247 4.26562 10.9997 4.26562C8.97463 4.26562 7.33301 5.9371 7.33301 7.99896C7.33301 10.0608 8.97463 11.7323 10.9997 11.7323Z",
    fill: "#F93939"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_6042_110645"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 22,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconJapan);
export default __webpack_public_path__ + "static/media/icon-japan.522aa824cf1f9f7593483ec41c88c516.svg";
export { ForwardRef as ReactComponent };